import Swal from 'sweetalert2/dist/sweetalert2';

export default {
  successAlert: Swal.mixin({
    icon: 'success'
  }),
  quickSuccessAlert: Swal.mixin({
    // showConfirmButton: false,
    confirmButtonColor: '#652f8f',
    timer: 2000,
    icon: 'success'
  }),
  confirmationAlert: Swal.mixin({
    icon: 'warning',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#652f8f',
    cancelButtonColor: '#e2e555'
  }),
  errorToast: Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'error',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  }),
  warningToast: Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    icon: 'warning',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  })
};
